/* YO&NO — UX: live search, size tools, delivery estimate, gift finder, recently viewed */
(function(){
  var $=function(s,r){return (r||document).querySelector(s)}, $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var nl=function(n,d){return Number(n).toLocaleString('nl-NL',{minimumFractionDigits:d,maximumFractionDigits:d})};
  var eur=function(v){return Number(v).toLocaleString('nl-NL',{style:'currency',currency:'EUR'})};
  var store={get:function(k){try{return JSON.parse(localStorage.getItem(k))}catch(e){return null}},set:function(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}};
  var esc=function(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})};

  /* ---------- live search ---------- */
  function initSearch(){
    var box=$('[data-yn-search]'); if(!box) return;
    var input=$('[data-yn-search-input]',box), start=$('[data-yn-search-start]',box), res=$('[data-yn-search-results]',box),
        grid=$('[data-yn-search-grid]',box), qs=$('[data-yn-search-queries]',box), cols=$('[data-yn-search-cols]',box), all=$('[data-yn-search-all]',box);
    var timer, ctrl, last='';
    function open(){ box.hidden=false; document.documentElement.classList.add('yn-lock'); requestAnimationFrame(function(){box.classList.add('is-open'); input.focus();}); }
    function close(){ box.classList.remove('is-open'); document.documentElement.classList.remove('yn-lock'); setTimeout(function(){box.hidden=true},250); }
    document.addEventListener('click',function(e){
      var t=e.target.closest('.header__search summary, .header__icon--search, [data-yn-search-open]');
      if(t){ e.preventDefault(); e.stopPropagation(); var d=t.closest('details'); if(d) d.removeAttribute('open'); open(); }
    },true);
    $$('[data-yn-search-close]',box).forEach(function(b){b.addEventListener('click',close)});
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !box.hidden) close(); if(e.key==='/' && box.hidden && !/input|textarea/i.test((document.activeElement||{}).tagName)){ e.preventDefault(); open(); } });
    $$('[data-yn-term]',box).forEach(function(b){b.addEventListener('click',function(){ input.value=b.dataset.ynTerm; run(); input.focus(); })});
    input.addEventListener('input',function(){ clearTimeout(timer); timer=setTimeout(run,160); });
    function run(){
      var q=input.value.trim(); if(q===last) return; last=q;
      if(q.length<2){ res.hidden=true; start.hidden=false; return; }
      if(ctrl) ctrl.abort(); ctrl=('AbortController' in window)?new AbortController():null;
      var url=(window.routes&&window.routes.predictive_search_url||'/search/suggest')+'.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
      box.classList.add('is-loading');
      fetch(url,ctrl?{signal:ctrl.signal}:{}).then(function(r){return r.json()}).then(function(j){
        var R=(j.resources&&j.resources.results)||{}; var P=R.products||[], C=R.collections||[], Q=R.queries||[];
        start.hidden=true; res.hidden=false;
        all.href='/search?q='+encodeURIComponent(q)+'&options[prefix]=last&type=product';
        all.textContent='Bekijk alle resultaten voor “'+q+'”';
        qs.innerHTML=Q.length?'<p class="yn-search__h">Suggesties</p>'+Q.slice(0,5).map(function(x){return '<a class="yn-search__q" href="'+esc(x.url)+'">'+(x.styled_text||esc(x.text))+'</a>'}).join(''):'';
        cols.innerHTML=C.length?'<p class="yn-search__h">Collecties</p>'+C.slice(0,5).map(function(x){return '<a class="yn-search__q" href="'+esc(x.url)+'">'+esc(x.title)+'</a>'}).join(''):'';
        grid.innerHTML=P.length?P.map(function(p){
          var img=p.featured_image&&p.featured_image.url?p.featured_image.url:(p.image||'');
          if(img) img+=(img.indexOf('?')>-1?'&':'?')+'width=360';
          var sale=p.compare_at_price_max&&Number(p.compare_at_price_max)>Number(p.price);
          return '<a class="yn-sr" href="'+esc(p.url)+'"><span class="yn-sr__img">'+(img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'')+'</span><span class="yn-sr__t">'+esc(p.title)+'</span><span class="yn-sr__p'+(sale?' is-sale':'')+'">'+(p.price_max!==p.price_min?'vanaf ':'')+eur(p.price_min||p.price)+'</span></a>';
        }).join(''):'<p class="yn-search__empty">Geen producten gevonden voor “'+esc(q)+'”. Probeer een ander woord, zoals <em>ketting</em> of <em>oorbellen</em>.</p>';
      }).catch(function(){}).finally(function(){box.classList.remove('is-loading')});
    }
  }

  /* ---------- size tools ---------- */
  var CUTS=[[36,'Sluit om de hals, een chokerlengte.'],[38,'Kort en sierlijk, vlak boven het sleutelbeen.'],[40,'Valt net onder de hals. Mooi voor een klein hangertje.'],[42,'Valt net onder de hals. Mooi voor een klein hangertje.'],[45,'Op het sleutelbeen: de lengte die de meeste mensen kiezen.'],[50,'Net onder het sleutelbeen, mooi over een col of blouse.'],[55,'Valt op de borst. Mooi om te combineren met een kortere ketting.'],[60,'Valt op de borst. Mooi om te combineren met een kortere ketting.'],[70,'Lang, mooi over een trui of dubbel gedragen.'],[80,'Heel lang, ook dubbel om te dragen.']];
  function pxPerMm(){ var s=store.get('yn_ppm'); return s||(96/25.4); }
  function findOption(re,target,tol){
    var best=null,bd=1e9;
    $$('variant-selects input[type=radio], variant-selects select option').forEach(function(el){
      var v=el.value||''; var m=v.replace(',','.').match(/(\d+(?:\.\d+)?)/); if(!m) return;
      if(re && !re.test((el.closest('fieldset,div.product-form__input')||{}).textContent||'')) {}
      var d=Math.abs(parseFloat(m[1])-target); if(d<bd){bd=d;best=el;}
    });
    return bd<=tol?best:null;
  }
  function chooseOption(el){
    if(!el) return;
    if(el.tagName==='OPTION'){ var s=el.parentElement; s.value=el.value; s.dispatchEvent(new Event('change',{bubbles:true})); }
    else { el.checked=true; el.dispatchEvent(new Event('change',{bubbles:true})); }
  }
  function initTools(root){
    $$('[data-yn-tools]',root).forEach(function(w){
      if(w.dataset.ready) return; w.dataset.ready=1;
      var pdp=w.dataset.context==='pdp';
      var tabs=$$('[data-tool]',w), panels=$$('[data-tool-panel]',w);
      function show(t){ tabs.forEach(function(b){b.setAttribute('aria-selected',b.dataset.tool===t)}); panels.forEach(function(p){p.hidden=p.dataset.toolPanel!==t}); }
      tabs.forEach(function(b){b.addEventListener('click',function(){show(b.dataset.tool)})});
      show(w.dataset.start||'ring');
      w.addEventListener('yn:show',function(e){show(e.detail)});
      function apply(btn,el,label){ if(!pdp||!el){btn.hidden=true;return;} btn.hidden=false; btn.textContent='Kies '+label; btn.onclick=function(){ chooseOption(el); var d=w.closest('dialog'); if(d) d.close(); }; }

      /* ring */
      var rr=$('[data-ring-range]',w), rc=$('[data-ring-circle]',w), rl=$('[data-ring-label]',w), ro=$('[data-ring-out]',w), rm=$('[data-ring-maat]',w), circ=$('[data-ring-circ]',w), rApply=$('[data-tool-panel=ring] [data-apply]',w);
      function ring(d){
        var ppm=pxPerMm(); var px=d*ppm; rc.style.width=rc.style.height=px+'px';
        var c=Math.PI*d; rl.textContent=nl(d,2).replace(/,00$/,'')+' mm';
        ro.textContent=nl(d,2)+' mm'; rm.textContent='omtrek '+nl(c,1)+' mm · ringmaat '+Math.round(c);
        apply(rApply,findOption(null,d,0.26),nl(d,2)+' mm');
      }
      if(rr){ rr.addEventListener('input',function(){ring(parseFloat(rr.value))}); ring(parseFloat(rr.value));
        circ.addEventListener('input',function(){ var c=parseFloat((circ.value||'').replace(',','.')); if(c>30&&c<90){ var d=Math.round(c/Math.PI*4)/4; rr.value=d; ring(d);} });
        var cb=$('[data-calib-bar]',w), cr=$('[data-calib-range]',w), cs=$('[data-calib-save]',w);
        cr.value=Math.round(pxPerMm()*85.6); cb.style.width=cr.value+'px';
        cr.addEventListener('input',function(){cb.style.width=cr.value+'px'});
        cs.addEventListener('click',function(){ store.set('yn_ppm',parseFloat(cr.value)/85.6); ring(parseFloat(rr.value)); cs.textContent='Opgeslagen'; setTimeout(function(){cs.textContent='Opslaan'},1500); });
      }

      /* necklace */
      var chain=$('[data-neck-chain]',w), pend=$('[data-neck-pendant]',w), no=$('[data-neck-out]',w), nd=$('[data-neck-desc]',w), nApply=$('[data-tool-panel=ketting] [data-apply]',w);
      function neck(l){
        var y=Math.min(238,78+(l-36)*3.6); var cy=2*y-66;
        chain.setAttribute('d','M112 66 Q150 '+cy+' 188 66'); pend.setAttribute('cy',y+4);
        no.textContent=l+' cm'; var t=CUTS[0][1]; CUTS.forEach(function(c){ if(l>=c[0]) t=c[1]; }); nd.textContent=t;
        $$('[data-len]',w).forEach(function(b){b.classList.toggle('is-on',+b.dataset.len===l)});
        apply(nApply,findOption(null,l,1.1),l+' cm');
      }
      $$('[data-len]',w).forEach(function(b){b.addEventListener('click',function(){neck(+b.dataset.len)})});
      if(chain) neck(45);

      /* bracelet */
      var wr=$('[data-wrist-range]',w), wo=$('[data-wrist-out]',w), ws=$('[data-wrist-sub]',w), wring=$('[data-wrist-ring]',w), wApply=$('[data-tool-panel=armband] [data-apply]',w);
      function wrist(){
        var p=parseFloat(wr.value), f=parseFloat(($('[data-fit]:checked',w)||{}).value||1.5), L=Math.round((p+f)*2)/2;
        wo.textContent=nl(L,1).replace(',0','')+' cm'; ws.textContent='polsomtrek '+nl(p,1).replace(',0','')+' cm + '+nl(f,1).replace(',0','')+' cm speling';
        var s=60+(p-12)*9; wring.style.width=wring.style.height=s+'px'; wring.style.setProperty('--gap',(f*4)+'px');
        apply(wApply,findOption(null,L,0.6),nl(L,1).replace(',0','')+' cm');
      }
      if(wr){ wr.addEventListener('input',wrist); $$('[data-fit]',w).forEach(function(r){r.addEventListener('change',wrist)}); wrist(); }
    });
  }
  function initSizeModal(){
    var dlg=$('[data-yn-size-modal]'); if(!dlg) return;
    document.addEventListener('click',function(e){
      var b=e.target.closest('[data-yn-size-open]'); if(!b) return;
      e.preventDefault(); var t=$('[data-yn-tools]',dlg); if(t) t.dispatchEvent(new CustomEvent('yn:show',{detail:b.dataset.ynSizeOpen}));
      if(dlg.showModal) dlg.showModal(); else dlg.setAttribute('open','');
    });
    $$('[data-yn-modal-close]',dlg).forEach(function(b){b.addEventListener('click',function(){dlg.close()})});
    dlg.addEventListener('click',function(e){ if(e.target===dlg) dlg.close(); });
  }

  /* ---------- delivery estimate (3–5 working days) ---------- */
  function addWorkdays(d,n){ var x=new Date(d); while(n>0){ x.setDate(x.getDate()+1); var w=x.getDay(); if(w!==0&&w!==6) n--; } return x; }
  function initEta(){
    var f=function(d){return d.toLocaleDateString('nl-NL',{weekday:'short',day:'numeric',month:'long'})};
    $$('[data-yn-eta]').forEach(function(el){ var now=new Date(); el.textContent='Verwacht tussen '+f(addWorkdays(now,3))+' en '+f(addWorkdays(now,5)); });
  }

  /* ---------- gift finder ---------- */
  function initGift(){
    $$('[data-yn-gift]').forEach(function(box){
      var go=$('[data-gf-go]',box), matStep=$('[data-gf-step=mat]',box);
      function val(k){ var b=$('[data-gf='+k+'] .is-on',box); return b?b.dataset.v:''; }
      function upd(){
        var who=val('who'), bud=val('budget'), mat=val('mat');
        matStep.classList.toggle('is-dim',who!=='haar');
        var base= who==='kind'?'kinder-sieraden': who==='hem'?'vaderdag': (mat||'all');
        var p=bud.split('-'), q=[];
        if(p[0]) q.push('filter.v.price.gte='+p[0]); if(p[1]) q.push('filter.v.price.lte='+p[1]);
        go.href='/collections/'+base+(q.length?'?'+q.join('&'):'');
      }
      $$('[data-gf] button',box).forEach(function(b){ b.addEventListener('click',function(){ $$('button',b.parentElement).forEach(function(x){x.classList.remove('is-on')}); b.classList.add('is-on'); upd(); }); });
      upd();
    });
  }

  /* ---------- recently viewed ---------- */
  function initRecent(){
    var sec=$('[data-yn-recent]'); var cur=sec?sec.dataset.current:(window.ShopifyAnalytics&&null);
    var list=store.get('yn_recent')||[];
    if(sec&&cur){ list=[cur].concat(list.filter(function(h){return h!==cur})).slice(0,12); store.set('yn_recent',list); }
    if(!sec) return;
    var show=list.filter(function(h){return h!==cur}).slice(0,4); if(!show.length) return;
    var grid=$('[data-yn-recent-grid]',sec);
    Promise.all(show.map(function(h){return fetch('/products/'+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null})})).then(function(ps){
      ps=ps.filter(Boolean); if(!ps.length) return;
      grid.innerHTML=ps.map(function(p){ var img=p.featured_image?(p.featured_image.indexOf('//')===0?'https:'+p.featured_image:p.featured_image):''; if(img) img+=(img.indexOf('?')>-1?'&':'?')+'width=400';
        return '<a class="yn-sr" href="'+esc(p.url)+'"><span class="yn-sr__img">'+(img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'')+'</span><span class="yn-sr__t">'+esc(p.title)+'</span><span class="yn-sr__p">'+(p.price_varies?'vanaf ':'')+eur(p.price/100)+'</span></a>'; }).join('');
      sec.hidden=false;
    });
  }

  function init(root){ initTools(root); }
  document.addEventListener('DOMContentLoaded',function(){ initSearch(); init(); initSizeModal(); initEta(); initGift(); initRecent(); });
  document.addEventListener('shopify:section:load',function(e){ init(e.target); initGift(); });
})();
